import { acceptStringValue } from '../../field-viewer/shared-normalizers';
export const contactsAddressViewer = {
    autoComplete: 'street-address',
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map